export default "__VITE_ASSET__051bb0d0__"